import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/ui/Logo";

interface SiteHeaderProps {
  /** Optional element rendered on the left side of the bar (e.g. counter pill). */
  leftSlot?: ReactNode;
  /** Optional element rendered on the right side (e.g. user menu). */
  rightSlot?: ReactNode;
}

export function SiteHeader({ leftSlot, rightSlot }: SiteHeaderProps = {}) {
  const hasSlots = Boolean(leftSlot || rightSlot);
  return (
    <header className="border-b border-[#e2e8f0] bg-white">
      <div className="mx-auto flex h-12 max-w-[1280px] items-center px-4">
        {hasSlots ? (
          <>
            <div className="flex w-20 items-center justify-start">{leftSlot}</div>
            <div className="flex flex-1 items-center justify-center">
              <Logo size="sm" to="/" />
            </div>
            <div className="flex w-20 items-center justify-end">{rightSlot}</div>
          </>
        ) : (
          <div className="flex flex-1 items-center justify-center">
            <Logo size="sm" to="/" />
          </div>
        )}
      </div>
    </header>
  );
}

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-12 flex flex-col items-center gap-3 pb-6 text-sm text-[#6c757d]">
      <nav aria-label="Footer" className="flex gap-10 text-[13px]">
        <FooterLink to="/faq">FAQ</FooterLink>
        <FooterLink to="/rules">Rules</FooterLink>
        <FooterLink to="/about">About</FooterLink>
      </nav>
      <p className="text-xs text-[#94a3b8]">Finally &copy;{year}</p>
    </footer>
  );
}

function FooterLink({ to, children }: { to: string; children: string }) {
  return (
    <Link to={to} className="text-[#475569] hover:text-[#2563eb] transition-colors">
      {children}
    </Link>
  );
}
